<div *ngIf="!notFound">
    <div class="container mb-2">
        <div class="row">
            <div class="col-md-8 mt-3">
                <mlp-venue-content
                    [openMapEvent]="openMapEvent"
                    [pitchesWithSameSport]="pitchesWithSameSport"
                ></mlp-venue-content>
            </div>
            <div class="col-md-4 mt-3">
                <mlp-venue-sidebar
                    [openMapEvent]="openMapEvent"
                    [pitchesWithSameSport]="pitchesWithSameSport"
                ></mlp-venue-sidebar>
            </div>
        </div>
    </div>

    <mlp-partner-banner></mlp-partner-banner>

    <div
        *ngIf="venueService.pitchData?.data.attributes.mlp"
        class="fixed-bottom d-md-none mlp-fixed-request"
        [ngClass]="{ 'mlp-fade-out': !bookOnlineShow }"
    >
        <div class="p-2 mx-2">

            <div
                class="mb-3"
                *ngIf="venueService.pitchData?.data.attributes.online_booking && venueService?.pitchData?.data?.attributes?.widgetUrl"
            >
                <mlp-ng-button-atom
                    class="d-lg-block"
                    [label]="venueService.pitchData?.data.attributes.onlineBlockBooking ? 'Make a block booking' : 'Make a booking'"
                    fullWidth="1"
                    (click)="footerAction(venueService.pitchData?.data.attributes.widgetUrl)"
                ></mlp-ng-button-atom>
            </div>

            <div class="row">
                <div
                    [ngClass]="{
                        'col-6': contactService.status,
                        'col-12': !contactService.status
                    }"
                    *ngIf="
                        !venueService.pitchData?.data.attributes.online_booking
                    "
                >
                    <mlp-ng-button-atom
                        fullWidth="1"
                        btnType="button"
                        label="Enquire"
                        (click)="scrollToEnquiry()"
                    >
                    </mlp-ng-button-atom>
                </div>
                <div *ngIf="
                        venueService.pitchData?.included[0] &&
                        venueService.pitchData?.included[0].attributes
                            .show_phone
                    ">
                    <div
                        class="col-6"
                        *ngIf="
                            !venueService.pitchData?.data.attributes
                                .online_booking && contactService.status
                        "
                    >
                        <a
                            href="tel:{{
                                (venueService.pitchData?.included)[0].attributes
                                    .contact_number | ngxRemoveSpacers
                            }}"
                            class="sg-btn sg-btn--tertiary d-block"
                        >
                            Call
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #ngModal>
    <mlp-ng-modal-secondary>
        <div header></div>

        <div
            body
            class="text-center"
        >
            <h3 class="sg-heading__h3 text-uppercase">
                <span class="-highlight">Sign up</span>
                to our
                <span class="-highlight">mailing list</span>
            </h3>

            <p class="mb-3">
                Be the first to know when your local sports facilities open
            </p>

            <form
                action="https://playfinder.us7.list-manage.com/subscribe/post?u=a8becbd3c11bcdb30e3ca06cb&amp;id=c2e0463071"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                class="validate"
                target="_blank"
                novalidate
                *ngIf="!authService.user"
            >
                <input
                    type="email"
                    name="EMAIL"
                    class="form-control sg-input-group__input-molecule"
                    id="mce-EMAIL"
                    placeholder="Email address"
                    required
                />
                <input
                    name="CITY"
                    class="d-none"
                    id="mce-CITY"
                    [value]="cityService.city.name"
                />
                <input
                    name="AREA"
                    class="d-none"
                    id="mce-AREA"
                    value="Central"
                />
                <input
                    name="SPORT"
                    class="d-none"
                    id="mce-SPORT"
                    [value]="
                        sport ? sport[0].toUpperCase() + sport.slice(1) : ''
                    "
                />
                <div
                    style="position: absolute; left: -5000px"
                    aria-hidden="true"
                >
                    <input
                        type="text"
                        name="b_a8becbd3c11bcdb30e3ca06cb_c2e0463071"
                        tabindex="-1"
                        value=""
                    />
                </div>
            </form>

            <mlp-ng-button
                (click)="marketingSignup()"
                label="Sign Up"
                btnStyle="secondary"
                class="d-block mt-3"
                fullWidth="1"
            ></mlp-ng-button>
        </div>
    </mlp-ng-modal-secondary>
</ng-template>
<mlp-not-found *ngIf="notFound"></mlp-not-found>
